import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import "../../styles/landing.css";
import {
  Business, LocalHospital, School, Store, Science,
  CardTravel, HomeWork, AttachMoney, AccountBalance,
  Gavel, Computer
} from "@mui/icons-material";

const industries = [
  { label: "Insurance", icon: <Business />, route: "insurance", color: "#1976d2" },
  { label: "Healthcare", icon: <LocalHospital />, route: "healthcare", color: "#e53935" },
  { label: "Education", icon: <School />, route: "education", color: "#8e24aa" },
  { label: "Small", icon: <Store />, route: "small-industries", color: "#f57c00" },
  { label: "Research", icon: <Science />, route: "research", color: "#43a047" },
  { label: "Travel", icon: <CardTravel />, route: "travel", color: "#00acc1" },
  { label: "Real Estate", icon: <HomeWork />, route: "real-estate", color: "#6d4c41" },
  { label: "Finance", icon: <AttachMoney />, route: "finance", color: "#2e7d32" },
  { label: "Banking", icon: <AccountBalance />, route: "banking", color: "#3949ab" },
  { label: "Legal", icon: <Gavel />, route: "legal", color: "#5e35b1" },
  { label: "IT", icon: <Computer />, route: "it", color: "#546e7a" },
];

const RadialHub = () => {
  const navigate = useNavigate();
  const hubRef = useRef();

  const cx = 300;
  const cy = 300;
  const r = 190;
  const labelR = r + 58;

  /* =========================
     MAGNETIC EFFECT
  ========================= */
  useEffect(() => {
    const nodes = document.querySelectorAll(".node-group");

    nodes.forEach((node) => {
      node.addEventListener("mousemove", (e) => {
        const rect = node.getBoundingClientRect();
        const dx = e.clientX - rect.left - rect.width / 2;
        const dy = e.clientY - rect.top - rect.height / 2;

        node.style.transform = `translate(${dx * 0.15}px, ${dy * 0.15}px) scale(1.2)`;
      });

      node.addEventListener("mouseleave", () => {
        node.style.transform = "translate(0,0) scale(1)";
      });
    });
  }, []);

  return (
    <div className="hub-container" ref={hubRef}>
      <svg viewBox="0 0 600 600" className="hub">

        {/* CENTER */}
        <circle cx={cx} cy={cy} r="55" className="center-node" />
        <text x={cx} y={cy} textAnchor="middle" dy="6" className="center-text">
          UDYOG
        </text>

        <g className="hub-rotate">
          {industries.map((item, i) => {
            const angle = (2 * Math.PI * i) / industries.length;
            const x = cx + r * Math.cos(angle);
            const y = cy + r * Math.sin(angle);
            const labelX = cx + labelR * Math.cos(angle);
            const labelY = cy + labelR * Math.sin(angle);
            const labelWidth = Math.max(38, item.label.length * 6.6 + 18);

            return (
              <g
                key={i}
                className="node-group"
                onClick={() => navigate(`/2.0/industry/${item.route}`)}
              >
                <g transform={`translate(${x}, ${y})`}>
                  <circle r="30" fill={item.color} className="node" />
                  <circle r="30" className="node-ripple" />

                  <g className="hub-upright">
                    <foreignObject x="-14" y="-14" width="28" height="28">
                      <div className="hub-icon">{item.icon}</div>
                    </foreignObject>
                  </g>
                </g>

                <g transform={`translate(${labelX}, ${labelY})`}>
                  <g className="hub-label-badge hub-upright">
                    <rect
                      x={-labelWidth / 2}
                      y="-12"
                      width={labelWidth}
                      height="24"
                      rx="12"
                    />
                    <text x="0" y="4" textAnchor="middle" className="label">
                      {item.label}
                    </text>
                  </g>
                </g>
              </g>
            );
          })}
        </g>
      </svg>
    </div>
  );
};

export default RadialHub;
